export default "__VITE_ASSET__DnReawpD__"